import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPageNumbers } from "../utils";
import { RadialBarChart, RadialBar, ResponsiveContainer} from "recharts";
import RootCauseAnalysisModal from "../components/RootCauseAnalysisModal";
import { apiFetch } from "../apiFetch";
/* ---------------- HELPERS ---------------- */
const badgeStyle = (status) => {
  switch (status) {
    case "Unmatched":
      return "bg-red-100 text-red-600";
    case "Matched":
      return "bg-gray-200 text-gray-700";
    case "Missing":
      return "bg-gray-300 text-gray-700";
    default:
      return "bg-gray-100";
  }
};

/* ---------------- COMPONENT ---------------- */

    const AgencyDrillDownPage = () => {

    const [agency,setAgency] = useState({name: "",id: "",contact: "",email: "",health: 94.2,total: 0,matched: 0,unmatched: 0,progress: 0,});
    const [transactions, setTransactions] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: Number(process.env.REACT_APP_PAGINATION_LIMIT),
        total: 0,
        totalPages: 1,
    });

    const { state } = useLocation();
    console.log(`STate ${JSON.stringify(state)}`);
    const [selectedRow, setSelectedRow] = useState(null);
    const [rowDetails, setRowDetails] = useState(null);   // API response
    const [loading, setLoading] = useState(false);
    const [actionPopup, setActionPopup] = useState(null);
    const [actionComment, setActionComment] = useState("");
    const [statusFilter, setStatusFilter] = useState("Unmatched");
    const [showRootCause, setShowRootCause] = useState(false);
    const [selectedTransformRules,setSelectedTransformRules] =useState([]);
    const [summaryData,setSummaryData] = useState(null);


      useEffect(() => {
          setAgency(state?.agency);
          getAgencyData(pagination.page,pagination.limit);
          if(state.agency=='all'){
             getSummaryData()
          }
      }, []);

      
      useEffect(() => {
        setAgency(state?.agency);
        getAgencyData(pagination.page,pagination.limit);
      }, [statusFilter]);
      
      async function getAgencyData(page,limit){
    
         // Fix if accidentally event is passed
      if (typeof page !== "number") {
        page = 1;
        limit = Number(process.env.REACT_APP_PAGINATION_LIMIT);
      }
        apiFetch(
            
              "file-mapping-config/get-invoice-transactions",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                configId: state?.file_mapping_id,
                uploadedFileId: state?.uploadedFileId,
                compositeKey:state.agency=="all"?"all":state?.agency?.id,
                page,
                limit,
                statusFilter
              }),
            }
          ) // <-- replace if needed
          .then((res) => res.json())
          .then((res) => {
            console.log(`res.data   ${res.data}`)
    
            setTransactions(transformed(res));
            setPagination(res.data.pagination || {});
    
          })
          .catch((err) => {
            console.error("API error:", err);
          })
          .finally(() => {});
      }

   function transformed(response) {

  let data = response?.data?.data || [];
  let final_output = response?.final_output || [];

  const sourceField = final_output?.[0]?.source_column;
  const targetField = final_output?.[0]?.target_column;

  return data.map((item) => {

    const sourceKey = `s_${sourceField}`;
    const targetKey = `t_${targetField}`;

    const sourceAmount = parseFloat(
      String(item[sourceKey] || 0).replace(/,/g, "")
    );

    const targetAmount = parseFloat(
      String(item[targetKey] || 0).replace(/,/g, "")
    );

    const varianceAmount = sourceAmount - targetAmount;

    // FINAL STATUS
    let status = "Unmatched";

    if (item.reconciliation_status === "IGNORED") {
      status = "Ignored";
    } else if (item.reconciliation_status === "RESOLVED") {
      status = "Resolved";
    } else if (item.final_output === "TRUE") {
      status = "Matched";
    }

    return {
      id: item.transaction_id,

      date: new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      }),

      source: sourceAmount.toLocaleString("en-US", {
        style: "currency",
        currency: "INR",
      }),

      target: targetAmount.toLocaleString("en-US", {
        style: "currency",
        currency: "INR",
      }),

      variance: `${
        varianceAmount >= 0 ? "+" : "-"
      }${Math.abs(varianceAmount).toLocaleString("en-US", {
        style: "currency",
        currency: "INR",
      })}`,

      status,

      reconciliationStatus: item.reconciliation_status,

      actionType: item.action_type,
      comment: item.comment,

      field: sourceField,

      rawSource: item[sourceKey],
      rawTarget: item[targetKey],

      matched: status === "Matched",
    };
  });
}   

const getColor = (value) => {
  if (value >= 90) return "#16a34a"; // green
  if (value >= 70) return "#2563eb"; // blue
  return "#dc2626"; // red
};
 /**=========================================
 * PAGINATION BUTTONS
 ==========================================*/
  const pages = getPageNumbers(pagination.page, pagination.totalPages);

  const handleNext = () => {
    if (pagination.page < pagination.totalPages) {
      getAgencyData(pagination.page + 1, pagination.limit);
    }
  };

  const handlePrev = () => {
    if (pagination.page > 1) {
      getAgencyData(pagination.page - 1, pagination.limit);
    }
  };

  const handlePageSizeChange = (e) => {
     //  Reset to first page when page size changes
    const newLimit = Number(e.target.value);
    getAgencyData(1, newLimit);
   
  };


const chartData = [
  {
    name: "progress",
    value: agency?.progress, // filled part
    fill: "#2563eb",
  },
  {
    name: "remaining",
    value: 100, // remaining part
    fill: "#D1DBD4",
  },
];

/**============================
 * ROW SELECTION
 =================================*/

const handleRowClick = async (row) => {

  console.log('handleClick ',JSON.stringify(row));
  
  setSelectedRow(row);     // open panel immediately
  setLoading(true);

  try {
        apiFetch( "file-mapping-config/get-transaction-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
              configId: state?.file_mapping_id,
              uploadedFileId: state?.uploadedFileId,
              transactionId: row.id,
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
          //let esData = data?.data;
          //alert(JSON.stringify(esData))
          setRowDetails(data)
          //console.log(`data ${JSON.stringify(esData[0]?._source)}`);
          
          //setRowDetails(esData[0]?._source);   // full ES response
        }
      )
      .catch((err) => console.error(err));
      
    } catch (err) {
      console.error(err);
      alert("Process failed");
    } finally {
      setLoading(false);
    }
  
};
/**===============================
   * Save ACTION
   ==================================*/
   const saveAction = async (data) => {
   
    try {
      console.log("Saving payload:", JSON.stringify(data));
      try {
        await apiFetch("reconciliation-transaction-action", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        alert("Action Saved Successfully!");
        getAgencyData(pagination.page,pagination.limit);
  
      } catch (error) {
        console.error(error);
        alert("Error saving action");
      } finally {
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      alert("❌ Failed to save action");
    }
  };

  /**=================================
   * 
   ====================================*/

    useEffect(() => {
        console.log(`selectedTransformRules. ${JSON.stringify(selectedTransformRules)}`)
      }, [selectedTransformRules]);
  /**=========================================== 
   * Get Summary Data
  ==============================================*/
  function getSummaryData(){
      try {
        
        apiFetch("file-mapping-config/summary-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.uploadedFileId
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
          let response = data.data;
          setSummaryData(response)
        }
        )
        .catch((err) => console.error(err));
        
      } catch (err) {
        console.error(err);
       
      } finally {
        // setRunning(false);
      }

    }


const Card = ({ title, desc, type, icon,isprogress=false,color }) => (
  <div  className="bg-white p-6 rounded-xl shadow hover:scale-[1.02] cursor-pointer transition">
    <div className="flex justify-between items-start mb-4">
      <div className={`p-3 ${color} rounded-lg`}>
        <span className="material-symbols-outlined text-blue-600 text-xl">
          {icon}
        </span>
      </div>

      <div className="flex flex-col items-end">
        <span className="text-[10px] font-bold text-gray-500 uppercase">
         {type}
        </span>
        {/* <span className="font-bold text-blue-600">
          {percent ? percent.toFixed(2) + "%" : "NA"}
        </span> */}
    
      </div>
    </div>

    <h4 className="font-bold text-gray-800 text-lg mb-1">{title}</h4>
    {!isprogress &&  <p className="text-sm text-gray-500">{desc}</p>}
    {isprogress && (
            <div className="w-full h-2 bg-gray-200 rounded mt-2">
            <div
              className="h-2 bg-blue-600 rounded"
              style={{ width: `${agency?.progress?agency?.progress:summaryData?.accuracy?.toFixed(2)}%` }}
            />
          </div>
        )
         }
  </div>
);
/**================================================ */

/**================================================ */
const filteredTransactions = transactions.filter((trx) => {

  if (statusFilter === "ALL") {
    return true;
  }

  return trx.status === statusFilter;
});
/**================================================ */

/**================================================ */
  return (
    <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 min-h-screen flex flex-col">
      
      {/* MAIN */}
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">      
      {/* Breadcrumb */}
      {agency!='all' && <div className="text-sm text-gray-500 mb-4">
        Agencies &nbsp;›&nbsp;{" "}
        <span className="text-gray-700 font-medium">
          {agency?.name}
        </span>
      </div>}

      

      {/* Header Card */}
      <div className="bg-white rounded-2xl shadow-sm p-6 flex justify-between items-center">
        <div>
         {agency!='all'?  
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold text-gray-800">
              {agency?.name}
            </h1>
            <span className="bg-gray-200 text-gray-600 text-xs px-3 py-1 rounded-full">
              {agency?.id}
            </span>
          </div> : 
          <div className=" items-center gap-3"> 
            <h1 className="mt-2 text-2xl font-black text-slate-900">
                Transaction Explorer
              </h1>

              <p className="sm text-slate-500">
                Browse every transaction with reconciliation status and filters.
              </p>
           
          </div>
          
          }
          

        <p className="text-gray-500 font-bold mt-1">
          {state.config_name}
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
                        <div className="text-xs font-medium text-slate-700 truncate">
                          Source File : {state?.source_file_name}
                        </div>
                        <div className="text-xs font-medium text-slate-700 truncate">
                         Target File : {state?.target_file_name}
                        </div>

                    </div>
          {agency!='all' && <div className="flex gap-6 mt-3 text-gray-600 text-sm">
            <span>👤 {agency?.contact}</span>
            <span>✉️ {agency?.email}</span>
            <span>🛡 Verified Partner</span>
          </div>}
        </div>

        {/* Health Score */}
        {/* <div className="bg-gray-100 rounded-xl p-4 flex items-center gap-4">
          <div>
            <p className="text-xs text-gray-500 uppercase">
              Health Score
            </p>
            <p className="text-2xl font-bold text-blue-600">
              {agency?.progress}%
            </p>
          </div>

          <div className="w-14 h-14 rounded-full border-4 border-blue-500 flex items-center justify-center text-blue-500">
            ↗
          </div>
        </div> */}
        <div className="bg-gray-100 rounded-xl p-4 flex items-center gap-4">
          <div>
            <p className="text-xs text-gray-500 uppercase">
              Health Score
            </p>

            <h1 className="text-2xl font-bold text-blue-600">
              {agency?.progress?agency?.progress:summaryData?.accuracy?.toFixed(2)}%
            </h1>
          </div>

          <div className="w-16 h-16">
            <ResponsiveContainer width="100%" height="100%">
              <RadialBarChart
                cx="50%"
                cy="50%"
                innerRadius="70%"
                outerRadius="100%"
                barSize={10}
                data={chartData}
                startAngle={90}
                endAngle={-270}
              >
                <RadialBar
                  dataKey="value"
                  cornerRadius={20}
                />
              </RadialBarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Metrics */}
      <div className="grid md:grid-cols-4 gap-6 mt-6">
         <Card
            title={agency?.total?agency?.total:summaryData?.targetUniqueCount}
            type="MTD Total"
            icon="payments"
            desc="Total Transactions"
            color="bg-blue-100"
          />
        
        <Card
            title={agency?.matched?agency?.matched:summaryData?.matchedCount}
            type="Confidence High"
            icon="check_circle"
            desc="Successfully Matched"
            color="bg-green-100"
          />

        <Card
            title={agency?.unmatched?agency?.unmatched:summaryData?.missMatchedCount}
            type="Action Required"
            icon="warning"
            desc="Unmatched Discrepancies"
            color="bg-red-100"
          />

        <Card
            title={ (agency?.progress? agency?.progress+"%" : summaryData?.accuracy?.toFixed(2) + "%")}
            type="Status"
            icon="data_exploration"
            desc="Progress"
            isprogress={true}
            color="bg-blue-100"
          />
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-2xl shadow-sm mt-8 overflow-hidden">
        
        {/* Header */}
        <div className="p-5 flex justify-between items-center border-b">

            {/* LEFT */}
            <div className="flex items-center gap-3 flex-wrap">

              <h2 className="font-semibold text-lg">
                Transaction Ledger
              </h2>

              {/* <span className="bg-blue-600 text-white text-xs px-3 py-1 rounded">
                OCTOBER 2023
              </span> */}

              <span className="bg-gray-200 text-gray-600 text-xs px-3 py-1 rounded">
                FILTERED: {statusFilter}
              </span>

              {/* FILTER BUTTONS */}
              <div className="flex items-center gap-2 ml-2">

                <button
                  onClick={() => setStatusFilter("ALL")}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition ${
                    statusFilter === "ALL"
                      ? "bg-black text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                >
                  All
                </button>

                <button
                  onClick={() => setStatusFilter("Matched")}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition ${
                    statusFilter === "Matched"
                      ? "bg-green-600 text-white"
                      : "bg-green-100 text-green-700 hover:bg-green-200"
                  }`}
                >
                  Matched
                </button>

                <button
                  onClick={() => setStatusFilter("Unmatched")}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition ${
                    statusFilter === "Unmatched"
                      ? "bg-red-600 text-white"
                      : "bg-red-100 text-red-700 hover:bg-red-200"
                  }`}
                >
                  Unmatched
                </button>
                <button
                  onClick={() => setStatusFilter("Resolved")}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition ${
                    statusFilter === "Resolved"
                      ? "bg-green-600 text-white"
                      : "bg-green-100 text-green-700 hover:bg-green-200"
                  }`}
                >
                  Resolved
                </button>
                <button
                  onClick={() => setStatusFilter("Ignored")}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition ${
                    statusFilter === "Ignored"
                      ? "bg-gray-600 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  Ignored
                </button>

              </div>
            </div>

            {/* RIGHT */}
            <div className="flex gap-3">

              <input
                placeholder="ID, Status or Date..."
                className="border rounded-lg px-3 py-2 text-sm"
              />

              <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                Export Report
              </button>

            </div>
          </div>

        {/* Table */}
        <table className="w-full text-sm">
          <thead className="text-gray-500 text-xs uppercase bg-gray-50">
            <tr>
              <th className="p-4 text-left">Transaction ID</th>
              <th>Date</th>
              <th>Source Value</th>
              <th>Target Value</th>
              <th>Variance</th>
              <th>Status</th>
              <th></th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {transactions.map((trx, i) => (
              <tr key={i} className="border-t hover:bg-gray-50" >
                <td className="p-4 font-semibold">{trx.id}</td>
                <td>{trx.date}</td>
                <td>{trx.source}</td>
                <td>{trx.target}</td>
                <td
                  className={
                    trx?.variance?.includes("-")
                      ? "text-red-600"
                      : ""
                  }
                >
                  {trx.variance}
                </td>
                <td>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${badgeStyle(
                      trx.status
                    )}`}
                  >
                    {trx.status}
                  </span>
                </td>
                 <td className="text-right pr-4">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRowClick(trx);
                    }}
                    className="text-blue-600 text-sm font-semibold hover:underline"
                  >
                    Review
                  </button>
                </td>
                <td className="px-6 py-4 border-b text-center">

                    {trx.status=='Unmatched' ? (
                      <div className="flex items-center justify-center gap-2">

                        <button
                          className="bg-green-100 hover:bg-green-200 text-green-700 px-3 py-1 rounded-lg text-xs font-semibold transition"
                          onClick={() => {
                            setActionPopup({
                              type: "Resolve",
                              row:trx
                            });

                            setActionComment("");
                          }}
                        >
                          Resolve
                        </button>

                        <button
                          className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded-lg text-xs font-semibold transition"
                          onClick={() => {
                            setActionPopup({
                              type: "Ignore",
                              row:trx
                            });

                            setActionComment("");
                          }}
                        >
                          Ignore
                        </button>

                      </div>
                    ) : (
                      <span className="text-gray-400 text-xs">
                        —
                      </span>
                    )}

                  </td>
                
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer */}
        <div className="p-4 text-xs text-gray-500  justify-between">
          {/* PAGINATION */}
         <div className="mt-10 text-center">
            <div className="flex justify-between items-center mt-4">

              {/* LEFT */}
              <div className="text-sm text-gray-600">
                Showing{" "}
                {(pagination.page - 1) * pagination.limit + 1}
                {" - "}
                {Math.min(pagination.page * pagination.limit, pagination.total)}
                {" of "}
                {pagination.total}
              </div>

              {/* RIGHT */}
              <div className="flex items-center gap-4">

                {/* Page Size */}
                <div className="flex items-center gap-2">
                  <span className="text-sm">Rows:</span>
                  <select
                    value={pagination.limit}
                    onChange={handlePageSizeChange}
                    className="border px-2 py-1 rounded"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>

                {/* Prev */}
                <button
                  onClick={handlePrev}
                  disabled={pagination.page === 1}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Prev
                </button>

                {/* Page Info */}
                  {pages.map((p, i) =>
                    p === "..." ? (
                      <span key={i} className="px-2">...</span>
                    ) : (
                      <button
                        key={i}
                        onClick={() => getAgencyData(p, pagination.limit)}
                        className={`px-2 py-1 border rounded ${
                          p === pagination.page ? "bg-blue-500 text-white" : ""
                        }`}
                      >
                        {p}
                      </button>
                    )
                  )}

                {/* Next */}
                <button
                  onClick={handleNext}
                  disabled={pagination.page === pagination.totalPages}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Next
                </button>

              </div>
            </div>
        </div>
        </div>
      </div>
      
      {/** Action POPUP */}
      {/* ACTION COMMENT POPUP */}
        {actionPopup && (
          <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-6">

            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">

              {/* HEADER */}
              <div className="flex justify-between items-center border-b px-6 py-4">

                <div>
                  <h2 className="text-xl font-bold text-gray-800">
                    {actionPopup.type} Unmatched
                  </h2>

                  <p className="text-sm text-gray-500 mt-1">
                    {actionPopup?.row?.field}
                  </p>
                </div>

                <button
                  onClick={() => {
                    setActionPopup(null);
                    setActionComment("");
                  }}
                  className="text-gray-500 hover:text-black text-xl"
                >
                  ✕
                </button>
              </div>

              {/* BODY */}
              <div className="p-6">

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Comment
                  </label>

                  <textarea
                    rows={5}
                    value={actionComment}
                    onChange={(e) => setActionComment(e.target.value)}
                    placeholder={`Enter reason for ${actionPopup.type.toLowerCase()}...`}
                    className="w-full border rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  />
                </div>

                {/* INFO */}
                <div className="bg-gray-50 rounded-xl p-4 text-sm mb-6">

                  <div className="mb-2">
                    <span className="font-semibold text-gray-700">
                      Source:
                    </span>{" "}
                    {String(actionPopup?.row?.source || "-")}
                  </div>

                  <div>
                    <span className="font-semibold text-gray-700">
                      Target:
                    </span>{" "}
                    {String(actionPopup?.row?.target || "-")}
                  </div>

                </div>

                {/* FOOTER */}
                <div className="flex justify-end gap-3">

                  <button
                    onClick={() => {
                      setActionPopup(null);
                      setActionComment("");
                    }}
                    className="px-4 py-2 rounded-xl border text-gray-600 hover:bg-gray-100"
                  >
                    Cancel
                  </button>

                  <button
                    disabled={!actionComment.trim()}
                    onClick={() => {

                        let data = {
                        action_type: actionPopup.type.toUpperCase(),
                        field: actionPopup.row.field,
                        comment: actionComment,
                        source: actionPopup.row.source,
                        target: actionPopup.row.target,
                        transaction_id:actionPopup.row.id,
                        status:'ACTIVE' ,        
                        config_id: state?.file_mapping_id,
                        uploaded_file_id: state?.uploadedFileId
                      }
                   
                      // CALL API HERE
                      
                      saveAction(data);
                     
                      setActionPopup(null);
                      setActionComment("");
                    }}
                    className={`px-4 py-2 rounded-xl text-white font-medium ${
                      actionPopup.type === "Resolve"
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-gray-700 hover:bg-black"
                    } disabled:opacity-50`}
                  >
                    Confirm {actionPopup.type}
                  </button>

                </div>
              </div>
            </div>
          </div>
        )}
      {/* REVIEW POPUP */}
      <RootCauseAnalysisModal
            configId={state?.file_mapping_id}
            open={!!selectedRow}
            loading={loading}
            rowDetails={rowDetails}
            transactionId={selectedRow?.id}
            onClose={() => {
              setSelectedRow(null);
              setRowDetails(null);
            }}
             onRulesChange={
                  setSelectedTransformRules
              }
          />
      </main>
    </div>
  );
};



export default AgencyDrillDownPage;